import React from 'react';
import PropTypes from 'prop-types';
import { DialogActions, Button } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { useFormikContext } from 'formik';
import { LoadingButton } from '~/modules/common/components';

const SetResourceAllocationDialogFooter = ({ onClose }) => {
  const { handleSubmit, isSubmitting } = useFormikContext();

  return (
    <DialogActions>
      <Button
        data-qe-id="SetResourceAllocationDialog_CancelButton"
        disabled={isSubmitting}
        onClick={onClose}
        variant="contained"
      >
        <FormattedMessage id="setResourceAllocationDialog.cancel" />
      </Button>
      <LoadingButton
        color="primary"
        data-qe-id="SetResourceAllocationDialog_SubmitButton"
        disabled={isSubmitting}
        isLoading={isSubmitting}
        onClick={handleSubmit}
        variant="contained"
      >
        <FormattedMessage id="setResourceAllocationDialog.setResourceAllocation" />
      </LoadingButton>
    </DialogActions>
  );
};

SetResourceAllocationDialogFooter.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default SetResourceAllocationDialogFooter;
